import { config } from "@/config/env";
import { useEffect } from "react";
import { toast } from "react-toastify";

const LAST_VERSION_KEY = "deci.last-version";
const PRELOAD_RELOAD_KEY = "deci.preload-failed-reloaded";

const getCurrentVersion = () => {
  const version = config.APP_VERSION || "unknown";
  const hash = config.APP_HASH;
  return hash ? `${version}#${hash}` : version;
};

const safeGet = (key: string) => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key: string, value: string) => {
  try {
    window.localStorage.setItem(key, value);
  } catch {}
};

const safeRemove = (key: string) => {
  try {
    window.localStorage.removeItem(key);
  } catch {}
};

const AppVersionToasts = () => {
  useEffect(() => {
    const currentVersion = getCurrentVersion();
    const preloadFailedVersion = safeGet(PRELOAD_RELOAD_KEY);
    const lastVersion = safeGet(LAST_VERSION_KEY);

    if (lastVersion && lastVersion !== currentVersion) {
      if (preloadFailedVersion) {
        toast.success("Decisively has been updated.", {
          autoClose: 8000,
          toastId: "deci-version-updated",
        });
      }
      safeRemove(PRELOAD_RELOAD_KEY);
    }

    safeSet(LAST_VERSION_KEY, currentVersion);

    const handlePreloadError = (event: Event) => {
      event.preventDefault();

      if (safeGet(PRELOAD_RELOAD_KEY) === "true") {
        toast.error("Unable to load the latest app files. Please hard refresh the page.", {
          autoClose: false,
          toastId: "deci-preload-failed",
        });
        return;
      }

      safeSet(PRELOAD_RELOAD_KEY, "true");
      window.location.reload();
    };

    window.addEventListener("vite:preloadError", handlePreloadError);
    return () => window.removeEventListener("vite:preloadError", handlePreloadError);
  }, []);

  return null;
};

export default AppVersionToasts;
